import { render } from "./EditPriceGroup.vue?vue&type=template&id=e4ba2f00&ts=true"
import script from "./EditPriceGroup.vue?vue&type=script&lang=ts"
export * from "./EditPriceGroup.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\Hermelin\\hermelinshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__